import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'utcToLocal'
})
export class UtcToLocalPipe implements PipeTransform {

    transform(value: Date, args?: any): any {
        var dt = new Date(value);
        dt.setTime(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000);
        return dt;
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/utcToLocal.pipe.ts